import { PAGE_NUMBER_TRANS } from '../../translationValues';

export const pageNumberList = t => {
  const pageTrans = `${t(
    PAGE_NUMBER_TRANS.PAGE_CONTENT.key,
    PAGE_NUMBER_TRANS.PAGE_CONTENT.value,
  )} `;
  const type2Trans = `${pageTrans}1`;
  const type3Trans = `${pageTrans}1 of 10`;
  const type4Trans = `${pageTrans}1 / 10`;

  return [
    {
      id: 1021,
      name: '1',
      isText: true,
      thumbnail: '1',
      elementDetails: {
        type: 'text',
        value: '1',
        styles: {
          position: 'absolute',
          width: '60px',
          height: '24px',
          transform: 'translateX(0px) translateY(160px) rotate(0deg) scaleX(1) scaleY(1)',
          background: 'transparent',
        },
        pageNumberType: 1,
        contents: {
          style: {
            width: '60px',
            height: '24px',
            x: 0,
            y: 0,
          },
          contents: [
            {
              contentType: 'PARAGRAPH',
              style: {
                color: '#000000',
              },
              content: ' ',
            },
            {
              contentType: 'LINE_BREAK',
              content: '\n',
              style: {
                color: '#000000',
              },
            },
          ],
          contentType: 'text',
        },
      },
    },
    {
      id: 1022,
      name: type2Trans,
      isText: true,
      thumbnail: type2Trans,
      elementDetails: {
        type: 'text',
        value: type2Trans,
        styles: {
          position: 'absolute',
          width: '90px',
          height: '24px',
          transform: 'translateX(0px) translateY(160px) rotate(0deg) scaleX(1) scaleY(1)',
          background: 'transparent',
        },
        pageNumberType: 2,
        contents: {
          style: {
            width: '90px',
            height: '24px',
            x: 0,
            y: 0,
          },
          contents: [
            {
              contentType: 'PARAGRAPH',
              style: {
                color: '#000000',
              },
              content: pageTrans,
            },
            {
              contentType: 'LINE_BREAK',
              content: '\n',
              style: {
                color: '#000000',
              },
            },
          ],
          contentType: 'text',
        },
      },
    },
    {
      id: 1024,
      name: type3Trans,
      isText: true,
      thumbnail: type3Trans,
      elementDetails: {
        type: 'text',
        value: type3Trans,
        styles: {
          position: 'absolute',
          width: '150px',
          height: '24px',
          transform: 'translateX(0px) translateY(160px) rotate(0deg) scaleX(1) scaleY(1)',
          background: 'transparent',
        },
        pageNumberType: 3,
        contents: {
          style: {
            width: '150px',
            height: '24px',
            x: 0,
            y: 0,
          },
          contents: [
            {
              contentType: 'PARAGRAPH',
              style: {
                color: '#000000',
              },
              content: pageTrans,
            },
            {
              contentType: 'LINE_BREAK',
              content: '\n',
              style: {
                color: '#000000',
              },
            },
          ],
          contentType: 'text',
        },
      },
    },
    {
      id: 1023,
      name: type4Trans,
      isText: true,
      thumbnail: type4Trans,
      elementDetails: {
        type: 'text',
        value: type4Trans,
        styles: {
          position: 'absolute',
          width: '150px',
          height: '24px',
          transform: 'translateX(0px) translateY(160px) rotate(0deg) scaleX(1) scaleY(1)',
          background: 'transparent',
        },
        pageNumberType: 4,
        contents: {
          style: {
            width: '150px',
            height: '24px',
            x: 0,
            y: 0,
          },
          contents: [
            {
              contentType: 'PARAGRAPH',
              style: {
                color: '#000000',
              },
              content: pageTrans,
            },
            {
              contentType: 'LINE_BREAK',
              content: '\n',
              style: {
                color: '#000000',
              },
            },
          ],
          contentType: 'text',
        },
      },
    },
  ];
};

export const getPgNoDetailsAtIndex = (index, t) => {
  const { pageNumberType, contents } = pageNumberList(t)[index].elementDetails;
  const pageNumber = {
    pageNumberType,
    contents,
  };
  pageNumber.contents.style.width = Number(pageNumber.contents.style.width.replaceAll('px', ''));
  pageNumber.contents.style.height = Number(pageNumber.contents.style.height.replaceAll('px', ''));
  delete pageNumber.pageNumberType;
  delete pageNumber.contents.contents;
  return pageNumber;
};

export const getPageNoAdditionalContent = (type, ofText = 'of', currentNo = 1, totalPages = 10) => {
  switch (type) {
    case 1:
    case 2: {
      return `${currentNo}`;
    }
    case 3: {
      return `${currentNo} ${ofText} ${totalPages}`;
    }
    case 4: {
      return `${currentNo} / ${totalPages}`;
    }
    default: {
      return `${currentNo}`;
    }
  }
};
